export default "__VITE_ASSET__mWXc68z2__"